import React from 'react';
import { BadgeVariants } from '@packages/ui/shared';
import { CidCvnCheckResult } from '@packages/models/api/cid-cvn';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';
import { TextBadge } from '@packages/ui/shared';

function getCheckResultDisplayValue(result: CidCvnCheckResult): string {
    if (!result) {
        return 'N/A';
    }
    return result.trim().toUpperCase().replace(/_/g, ' ');
}

const variantMap: Record<CidCvnCheckResult, BadgeVariants> = {
    [CidCvnCheckResult.Pass]: 'green',
    [CidCvnCheckResult.Fail]: 'red',
    [CidCvnCheckResult.NoMatchFound]: 'yellow',
};

interface CidCvnCheckResultBadgeProps {
    result: CidCvnCheckResult;
    style?: StyleProp<ViewStyle>;
}

export function CidCvnCheckResultBadge({ result, style }: CidCvnCheckResultBadgeProps) {
    return (
        <TextBadge
            data-testid="check-result-badge"
            variant={variantMap[result]}
            style={[styles.badge, style]}
            textStyle={styles.text}
            typographyProps={{ numberOfLines: 1 }}
        >
            {getCheckResultDisplayValue(result)}
        </TextBadge>
    );
}

const styles = StyleSheet.create({
    badge: {
        paddingHorizontal: 8,
        borderRadius: 4,
    },
    text: {
        fontSize: 13,
        fontWeight: '600',
    },
});
